// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__UiFgg","list":"PatternAutocomplete_list__zgd4K"};